import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n\n  color: var(", ");\n  font-weight: var(", ");\n  font-style: normal;\n  letter-spacing: ", ";\n  text-decoration: none;\n\n  ", "\n\n  ", "\n  ", "\n\n  /* Prevent italic styles on nested elements */\n  i,\n  em {\n    font-style: inherit;\n  }\n\n  a {\n    padding-bottom: 0.06125em;\n\n    color: inherit;\n    font-weight: var(", ");\n    text-decoration: none;\n\n    border-bottom: 1px solid\n      var(", ");\n\n    transition: 250ms var(", ");\n    transition-property: color border-color;\n\n    &:focus {\n      color: var(", ");\n\n      border-bottom-color: var(\n        ", "\n      );\n    }\n\n    &:hover {\n      color: var(", ");\n\n      border-bottom-color: var(\n        ", "\n      );\n    }\n  }\n\n  sup {\n    vertical-align: 0.68em;\n  }\n\n  sub {\n    vertical-align: -0.275em;\n  }\n\n  sup,\n  sub {\n    font-size: 0.583em;\n\n    a {\n      border-bottom: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// eslint-disable-next-line import/named
import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { getEasing } from '../../utils/getEasing';

function isHeadline(variant) {
  return ['order1', 'order2', 'order3', 'order4', 'display1', 'display2'].includes(variant);
}

function getVariantColor(variant, theme) {
  switch (variant) {
    case 'order1':
    case 'display1':
    case 'display2':
      return theme.colors.ui.primary;

    default:
      return theme.colors.ui.secondary;
  }
}

export var StyledText = styled.span(_templateObject(), function (props) {
  return getVariantColor(props.variant, props.theme);
}, function (props) {
  return props.theme.fontWeights[props.weight];
}, function (props) {
  return isHeadline(props.variant) && '-0.015em';
}, function (props) {
  return injectTypography(props, props.variant);
}, injectOSXFontSmoothing(true), injectSpacing('margin'), function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.theme.colors.interaction.primary.default;
}, getEasing, function (props) {
  return props.theme.colors.interaction.primary.focus;
}, function (props) {
  return props.theme.colors.interaction.primary.focus;
}, function (props) {
  return props.theme.colors.interaction.primary.hover;
}, function (props) {
  return props.theme.colors.interaction.primary.hover;
});